


































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import gql from 'graphql-tag';
import store from '@/store';
import { parseError, UNKNOWN_ERROR } from '@/utils/errors.ts';

const EndSessionMutation = gql`
  mutation EndSession($sessionId: ID!) {
    endBowlingSession(sessionId: $sessionId)
  }
`;

@Component({
  components: {
  },
})
export default class EndSession extends Vue {
  @Prop({
    required: true,
    type: Object,
    validator: (obj: any) => Object.values(obj).every(Array.isArray),
  })
  public availableSessions!: { [id: string]: number[] };

  public sessionIdSelected: string | null = this.isSingleSession ? this.singleSessionId : null;

  public loading: boolean = false;
  public error: string | null = null;

  public endSession() {
    if (!this.sessionIdSelected) {
      this.error = 'Please select some sessions.';
      return;
    }

    this.loading = true;
    this.$apollo.mutate({
      mutation: EndSessionMutation,
      variables: { sessionId: this.sessionIdSelected },

    }).then((r) => {
      this.loading = false;
      this.$emit('sessionEnded');
    }).catch((e) => {
      this.loading = false;
      this.error = parseError(e) || UNKNOWN_ERROR;
    });
  }

  get singleSessionLanes() {
    return (this.isSingleSession || null) && [...Object.values(this.availableSessions)[0]];
  }

  get singleSessionId() {
    return (this.isSingleSession || null) && Object.keys(this.availableSessions)[0];
  }

  get isSingleSession() {
    return Object.keys(this.availableSessions).length === 1;
  }
}
